import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/use-auth-store';

export function useRequireAuth() {
  const { user, profile, isAuthenticated, isLoading, isHydrated } =
    useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isHydrated && !isLoading && !isAuthenticated) {
      const returnUrl = location.pathname + location.search;
      navigate(`/login?redirect=${encodeURIComponent(returnUrl)}`, {
        replace: true,
      });
    }
  }, [isAuthenticated, isLoading, isHydrated, navigate, location]);

  return { user, profile, isLoading: isLoading || !isHydrated };
}
